// extracted by mini-css-extract-plugin
export default {"footercomp":"footercomp__U8nim","container":"container__osN+7","footersection":"footersection__D2x+R","footertitle":"footertitle__3Moey","desc":"desc__jF4k3"};